<template>
  <div v-loading="listContentLoading">
    <el-input
      class="search-el"
      size="mini"
      v-model="query.title"
      clearable
      placeholder="打卡标题"
    ></el-input>
<!--    <el-date-picker
        class="search-el"
        size="small"
        v-model="query.start_end_at"
        value-format='yyyy-MM-dd HH:mm:ss'
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions">
    </el-date-picker>-->
    <el-select
        class="search-el"
        size="mini"
        v-model="query.status"
        placeholder="请选择状态"
        clearable
        filterable
    >
      <el-option label="全部" value="">全部</el-option>
      <el-option label="未开始" value="1">未开始</el-option>
      <el-option label="进行中" value="2">进行中</el-option>
      <el-option label="已结束" value="3">已结束</el-option>
    </el-select>
    <el-select
        class="search-el"
        size="mini"
        v-model="query.type"
        placeholder="活动类型"
        clearable
        filterable
    >
      <el-option label="全部" value="">全部类型</el-option>
      <el-option label="满减送" value="dec_give">满减送</el-option>
<!--      <el-option label="进行中" value="dec">满减</el-option>-->
      <el-option label="实付满赠" value="give">实付满赠</el-option>
    </el-select>
    <el-button type="primary" size="mini" @click="getActivityList()">
      查询</el-button
    >
    <el-button type="primary" size="mini" @click="goToDetails(0,1)">
      添加活动</el-button>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0;"
      >
        <el-table-column
            prop="id"
            label="活动ID"
            align="center"
            min-width="5%"
        ></el-table-column>
        <el-table-column
            prop="title"
            label="活动标题"
            align="center"
            min-width="15%"
        ></el-table-column>

        <el-table-column label="活动时间" align="center" min-width="11%">
          <template slot-scope="{ row }">
            <span>{{row.start_at}}</span>至<br>
            <span>{{row.end_at}}</span>
          </template>
        </el-table-column>

        <el-table-column
            prop="type"
            label="适用范围"
            align="center"
            min-width="7%"
        >
          <template slot-scope="{ row }">
            <span v-if="row.partake_product=='all'">全部</span>
            <span v-else-if="row.partake_product=='assign'">指定参加</span>
            <span v-else-if="row.partake_product=='assign_not'">指定不参加</span>
          </template>
        </el-table-column>

        <el-table-column
            prop="type"
            label="类型"
            align="center"
            min-width="7%"
        >
          <template slot-scope="{ row }">
            <span v-if="row.type=='dec_give'">满减送</span>
            <span v-else-if="row.type=='dec'">满减</span>
            <span v-else-if="row.type=='give'">实付满赠</span>
          </template>
        </el-table-column>

        <el-table-column
            prop="details"
            label="活动详情"
            align="center"
            min-width="25%"
        ></el-table-column>

        <el-table-column
            prop="status_title"
            label="状态"
            align="center"
            min-width="5%"
        ></el-table-column>


        <el-table-column label="支付订单" align="center" min-width="5%">
          <template slot-scope="{ row }">
            <el-button
                type="text"
                size="small"
                @click="goToOrderList(row.id)"
            >
              <div v-if="row.order_num">{{ row.order_num }}</div>
              <div v-else-if="!row.order_num">查看</div>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="参与人数" align="center" min-width="5%">
          <template slot-scope="{ row }">
            <span>{{row.user_num}}</span>
<!--            <el-button
                type="text"
                size="small"
            >
              <div v-if="row.user_num">{{ row.user_num }}</div>
              <div v-else-if="!row.user_num">0</div>
            </el-button>-->
          </template>
        </el-table-column>

        <el-table-column label="发布状态" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <div>
              <span v-if="row.status == 1" style="color: #67c23a"
              ><i class="el-icon-circle-check"></i> 已发布</span
              >
              <span v-else style="color: #909399"
              ><i class="el-icon-circle-close"></i> 未发布</span
              >
              <el-button
                  type="text"
                  size="small"
                  style="margin-left: 5px"
                  @click="
                  row.status == 1
                    ? updateStatus(row.id, 0)
                    : getConflictActivity(row.id)
                "
              >
                {{ row.status == 1 ? "下架" : "发布" }}
              </el-button>
            </div>
          </template>
        </el-table-column>

        <el-table-column
            prop="course_title"
            label="关联商品"
            align="center"
            min-width="10%"
        >
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" :disabled="row.partake_product=='all' || row.status == 1" @click="activityProduct(row.id, 1, row.partake_product)">关联商品</el-button>
          </template>
        </el-table-column>





        <el-table-column label="" align="center" min-width="15%">
          <template slot-scope="{ row }">
            <el-button
                type="text"
                size="small"
                :disabled="row.status ==1"
                @click="goToDetails(row.id,1)"
            >
              <div>编辑</div>
            </el-button>
<!--            <el-button
                type="text"
                size="small"
                @click="goToDetails(row.id)"
            >
              <div>复制</div>
            </el-button>-->
            <el-button
                type="text"
                size="small"
                @click="goToDetails(row.id,2)"
            >
              <div>详情</div>
            </el-button>

            <el-button
                type="text"
                size="small"
                :disabled="row.partake_product=='all'" @click="activityProduct(row.id, 2)"
            >
              <div>查看关联商品</div>
            </el-button>
          </template>
        </el-table-column>

      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getActivityList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

<!--    弹窗提示冲突活动-->
    <el-dialog
        title="冲突提示"
        :visible.sync="activityConflict.dialogActivity"
        :close-on-click-modal="true"
        :before-close="addEditFormOnClose"
        width="75%"
    >
      <template>
<!--        <el-alert
            title="继续上架后，全部商品在此活动类型下只参与当前上架活动，下列包含重复时间的活动将被下架"
            type="error">
        </el-alert>-->
      </template>

      <!--列表-->
      <el-table
          border
          ref="multipleTable"
          :data="activityConflict.result.data"
          highlight-current-row
          v-loading="activityConflict.listLoading1"
          style="..."
      >
        <el-table-column
            prop="title"
            label="活动名称"
            align="center"
        ></el-table-column>
        <el-table-column label="活动时间" align="center">
          <template slot-scope="{ row }">
            <span>{{row.start_at}}</span>至<span>{{row.end_at}}</span>
          </template>
        </el-table-column>
        <el-table-column label="活动类型" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.type=='dec_give'">满减送</span>
            <span v-else-if="row.type=='dec'">满减</span>
            <span v-else-if="row.type=='give'">实付满赠</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          @current-change="getConflictActivity(nowActivityId)"
          :current-page.sync="activityConflict.query.page"
          :page-size="activityConflict.query.limit"
          layout="total, prev, pager, next, jumper"
          :total="activityConflict.result.total"
      >
      </el-pagination>
      <div style="margin-top: 20px">
        <el-button @click="updateStatus(nowActivityId,1)"
        >确定上架</el-button
        >
        <!--        <el-button @click="toggleSelection()">取消选择</el-button>-->
      </div>
    </el-dialog>


    <!--    弹窗提示冲突商品-->
    <el-dialog
        title="冲突提示"
        :visible.sync="activityConflict.dialogProductActivity"
        :close-on-click-modal="true"
        :before-close="addEditFormOnClose"
        width="75%"
    >
      <template>
        <el-alert
            title="继续上架后，以下商品在包含重合时间的同类型活动只参与当前上架活动"
            type="error">
        </el-alert>
      </template>

      <!--列表-->
      <el-table
          border
          ref="multipleTable"
          :data="activityConflict.result.data"
          highlight-current-row
          v-loading="activityConflict.listLoading1"
          style="..."
      >
        <el-table-column
            prop="title"
            label="商品名称"
            align="center"
        ></el-table-column>
        <el-table-column label="商品图片" align="center">
          <template slot-scope="{ row }">
            <span><img :src="row.img_url" style="width: 40px" alt="" /></span>
          </template>
        </el-table-column>
        <el-table-column label="活动时间" align="center">
          <template slot-scope="{ row }">
            <span>{{row.start_at}}</span>至<span>{{row.end_at}}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="activity_title"
            label="冲突活动"
            align="center"
        ></el-table-column>
        <el-table-column label="活动类型" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.type=='dec_give'">满减送</span>
            <span v-else-if="row.type=='dec'">满减</span>
            <span v-else-if="row.type=='give'">实付满赠</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          @current-change="getConflictActivity(nowActivityId)"
          :current-page.sync="activityConflict.query.page"
          :page-size="activityConflict.query.limit"
          layout="total, prev, pager, next, jumper"
          :total="activityConflict.result.total"
      >
      </el-pagination>
      <div style="margin-top: 20px">
        <el-button @click="updateStatus(nowActivityId,1)"
        >确定上架</el-button
        >
        <!--        <el-button @click="toggleSelection()">取消选择</el-button>-->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getActivityList,
  updateStatus,
  getConflictActivity
} from "@/api/productActivity";

import { qrCode, copyData} from "@/api/common";

export default {
  data: function () {
    return {
      dialogVisible: false,
      dialogVisible2:false,
      dialogProduct:false,
      nowActivityId:0,
      liveURL: "",
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        title: "",
        start_end_at: "",
        status: "",
        type: "",
      },
      activityConflict:{//冲突活动数据
        dialogActivity:false,
        dialogProductActivity:false,
        listLoading1: false,
        query: {
          page: 1,
          limit: 10,
          activity_id:0,
        },
        result: {
          total: 0,
          data: [],
        },
      },
      statusList: [],
      attendanceList: [],
      activityList: [],

      listContentLoading: false,

      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    };
  },
  created: function () {
    this.getActivityList();
    /*getActivityList(this.query).then((response) => {
      this.list = response.data.list;
      this.total = response.data.total;
      this.loading = false;
    });*/
  },
  methods: {
    toChannelItemData(channel_id, channel_item_id) {
        this.$router.push({
            path: "/channel/itemData",
            query: {
                channel_id: channel_id,
                channel_item_id: channel_item_id
            },
        });
      },

    filterChannel(channel_id) {      
      return this.attendanceList[channel_id.toString()];
    },


    goToDetails(id,canEdit){

      this.$router.push({
        path: "/mall/activity/info",
        query: {id:id,canEdit:canEdit}
      });
    },
    goToOrderList(id){
      this.$router.push({
        path: "/mall/activity/order/list",
        query: {activity_id :id}
      });
    },

    getActivityList() {
      this.loading = true;
      getActivityList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
      this.activityConflict.dialogActivity = false;
      this.activityConflict.dialogProductActivity = false
    },

    //获取冲突的活动或者商品
    getConflictActivity(id) {
      this.activityConflict.listLoading1 = true;
      this.nowActivityId = id
      this.activityConflict.query.activity_id = id
      getConflictActivity(this.activityConflict.query).then((response) => {
        if(response.data.status == 0){
          this.updateStatus(id,1)
        }else if(response.data.status == 1){//活动弹窗
          this.activityConflict.dialogActivity = true;
          this.activityConflict.listLoading1 = false;
          this.activityConflict.result.data = response.data.list;
          this.activityConflict.result.total = response.data.total;
          this.activityConflict.listLoading1 = false;
        }else if(response.data.status == 2){//活动弹窗
          this.activityConflict.dialogProductActivity = true;
          this.activityConflict.listLoading1 = false;
          this.activityConflict.result.data = response.data.list;
          this.activityConflict.result.total = response.data.total;
          this.activityConflict.listLoading1 = false;
        }

      });
    },

    // 弹窗关闭
    addEditFormOnClose() {
      this.activityConflict.result = {
        total: 0,
        data: [],
      };
      this.activityConflict.dialogActivity = false;
      this.activityConflict.dialogProductActivity = false

      this.nowActivityId = 0;
    },

    //上下架
    updateStatus(id, status) {
      updateStatus({
        id: id,
        status: status,
      }).then((response) => {
        if (response.status == 2000) {
          this.getActivityList();
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
        } else {
         /* this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });*/
        }
      });
    },

    activityProduct(id,type,partake_product) {
      this.$router.push({
        path: '/mall/activity/product/list',
        query: {
          activity_id: id,
          type: type,
          partake_product: partake_product
        }
      })
    },

    copy(url) {
      copyData(url);
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },

    deleteChannelItem(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteChannelItem({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getActivityList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
  },
  mounted() {
    
  },
};
</script>
